module.exports = __webpack_public_path__ + "static/img/MECCANODORA.fd4ae3dd.png";